import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Download, FileText } from "lucide-react";

export default function Reports() {
  const [reports, setReports] = useState([]);
  useEffect(() => { api.get("/reports").then((r) => setReports(r.data)); }, []);

  return (
    <div data-testid="reports-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 anim-fadeup">
      <div className="section-label">Documents</div>
      <h1 className="font-display font-bold text-4xl sm:text-5xl text-slate-950 mt-3">Yearly reports & filings.</h1>
      <p className="mt-3 text-slate-600 max-w-2xl">
        Annual operations reports, capital improvement summaries, and grant-funded project documentation.
      </p>

      <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reports.map((r) => (
          <a
            key={r.id}
            href={r.pdf_url}
            target="_blank"
            rel="noreferrer"
            data-testid={`report-${r.id}`}
            className="group bg-white border border-slate-200 p-6 hover:border-slate-950 transition-colors flex flex-col"
          >
            <div className="flex items-center justify-between">
              <div className="font-display text-5xl font-bold text-slate-950">{r.year}</div>
              <FileText className="h-6 w-6 text-sky-600 group-hover:text-slate-950" />
            </div>
            <div className="font-display text-lg font-semibold mt-4 text-slate-950">{r.title}</div>
            <p className="text-sm text-slate-600 mt-2 flex-1 leading-relaxed">{r.summary}</p>
            <div className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-slate-950 group-hover:gap-3 transition-all">
              <Download className="h-4 w-4" /> Download PDF
            </div>
          </a>
        ))}
        {reports.length === 0 && <div className="text-slate-500">No reports posted yet.</div>}
      </div>
    </div>
  );
}
